module.exports = __webpack_public_path__ + "img/91.ad7ba97e.png";